export const ENV_VN = {
    mode: 'Staging'
    , production: false
    , msalConfig: {
         auth: {
            clientId: '30a3674e-07d8-4ec1-8160-2f559a66071e'
            , authority: 'https://login.microsoftonline.com/ae7498ce-d4a7-47cf-b9f9-380629597a47'
            , tenantId: 'ae7498ce-d4a7-47cf-b9f9-380629597a47'
        }
    }
    , apiConfig: {
        scopes: ['https://ConnectClient.onmicrosoft.com/30a3674e-07d8-4ec1-8160-2f559a66071e/eos.api.access']
        , uri: '/api/*'
        , postLogoutRedirectUri: 'https://easyorderstg.vnbizbox.com'
        , redirectUri: 'https://easyorderstg.vnbizbox.com'
    }
    , unauthorizedConfig: {
        unauthorizedUrl: 'https://easyorderstg.vnbizbox.com/#/unauthorized'
        , unauthorizedRedirect: 'https://easyorderstg.vnbizbox.com'
    }
    , redirectConfig: {
        connectPlusUrl: 'https://uat.clm.euris.com/dksh-hc'
        , connectClientUrl: 'https://flpnwc-xlgtvarz5i.dispatcher.ap1.hana.ondemand.com'
    }
  }


// WEBPACK FOOTER //
// ./src/environment/environment.vn.ts